import { connect } from 'react-redux'

import {
  getFeedLeaderBoardListBySection,
  getFeedPendingGetLeaderBoard,
  getFeedFilterByTeam,
  getFeedFilterByRange,
} from 'store/entities/feed/selectors'
import FeedLeaderBoardList from './FeedLeaderBoardList'
import { fetchLeaderBoard } from 'store/entities/feed/actions'
import withDidMountRequest from 'app/connectors/withDidMountRequest'

const mapStateToProps = state => ({
  byTeam: getFeedFilterByTeam(state),
  byRange: getFeedFilterByRange(state),
  leaderBoardList: getFeedLeaderBoardListBySection(state),
  pending: getFeedPendingGetLeaderBoard(state),
})

const mapDispatchToProps = {
  fetchLeaderBoard,
}

const mergeProps = ({ byTeam, byRange, ...stateProps }, { fetchLeaderBoard, ...dispatchProps }) => ({
  onRequest: () => fetchLeaderBoard({ team: byTeam, range: byRange }),
  ...stateProps,
  ...dispatchProps,
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withDidMountRequest(FeedLeaderBoardList))
